module.exports = __webpack_public_path__ + "img/logo-html-css.e2ca6f5d.png";